/*
 * @Copyright 2026. Institute for Future Intelligence, Inc.
 */

// Bump this when either the Terms of Service or the Privacy Policy is
// materially updated. The current value is stored on the user's Firestore
// record when they click Accept; users whose recorded value differs from
// this constant will be re-prompted on next sign-in.
export const LEGAL_VERSION = '2026-05-11';
